<template>
  <div class="simon-collapse" :id="id">
    <button class="toggle text filled white" @click.prevent="toggle()" :data-prid="prid" :aria-label="ariaLabel">
      <slot name="headline"></slot>
      <span class="toggle-icon" :class="{open: collapseExpanded}">
        <img aria-hidden="true" src="/files/flash/images/svg-icons/select-down-primary.svg">
      </span>
    </button>
    <b-collapse v-model="collapseExpanded" :accordion="group" @shown="scrollToCollapse()">
      <slot name="content"></slot>
    </b-collapse>
  </div>
</template>
<script>

export default {
  name: 'SimonCollapse',
  props: {
    id: {
      type: String,
      default: null
    },
    prid: {
      type: String,
      default: null
    },
    group: {
      type: String,
      default: null
    },
    expanded: {
      type: Boolean,
      default: false
    },
    // a custom ID must be defined before using the scrollOnExpanded prop.
    scrollOnExpanded: {
      type: Boolean,
      default: false
    },
    customAriaLabel: {
      type: String
    }
  },
  watch: {
    expanded: function (newVal) {
      if (newVal) {
        this.collapseExpanded = true
      }
    },
    collapseExpanded: function () {
      this.$emit('collapseUpdate', this.collapseExpanded)
    }
  },
  mounted () {
    if (this.expanded) {
      this.collapseExpanded = true
    }
  },
  data () {
    return {
      collapseExpanded: false
    }
  },
  methods: {
    toggle () {
      this.collapseExpanded = !this.collapseExpanded
    },
    open () {
      this.collapseExpanded = true
    },
    close () {
      this.collapseExpanded = false
    },
    scrollToCollapse () {
      if (this.scrollOnExpanded && this.id) {
        document.getElementById(this.id).scrollIntoView({ behavior: 'smooth' })
      }
    }
  },
  computed: {
    ariaLabel () {
      return (this.customAriaLabel ? this.customAriaLabel : this.getSlotText('headline')) + ' ' + (this.collapseExpanded ? 'Einklappen' : 'Ausklappen')
    }
  }
}
</script>
